module.exports = __webpack_public_path__ + "assets/home-slide2.45e4a1cb.webp";